import React, { useState } from 'react';
import api from "../../../../../../../../services/api";
import ReactBSAlert from "react-bootstrap-sweetalert";

import { Container, CircleContainer } from '../../../../../Estagios/ColorCircle/styles';
import ColorCircle  from '../../../../../Estagios/ColorCircle'
import Portal from "../../../../../../../../components/Portal";


import {
    Button,
    ListGroupItem,
    ListGroup,
    Row,
    Input,
    Spinner
} from "reactstrap";

function List({ estagios, empresa, funilId, reload = () => { }, notify }) {

    const [alert, setAlert] = useState(null)
    const [ordenando, setOrdenando] = useState(false)
    const [changeColor, setChangeColor] = useState(false)

    function showError(msg) {
        setAlert(
            <Portal id="sweet-alert-portal">
                <ReactBSAlert
                    danger
                    style={{ display: "block" }}
                    title="Erro"
                    onConfirm={() => setAlert(null)}
                    onCancel={() => setAlert(null)}
                    confirmBtnBsStyle="danger"
                    confirmBtnText="Ok"
                    btnSize=""
                >
                    {msg}
                </ReactBSAlert>
            </Portal>
        );
    }

    async function handleDelete(estagio) {
        if (window.confirm(`Deseja remover este estagio  ${estagio.nome}?`)) {
            try {
                await api.delete(`/common/empresas/${empresa.id}/funis/${funilId}/estagios/${estagio.id}`);
                notify("success", "Estagio removido");
                reload();
            } catch (error) {
                const response = error.response;
                console.error(error);
                const msg = (response && response.status === 400 && response.data && response.data[0] && response.data[0].message)
                    ? response.data[0].message
                    : "Não foi possível remover o estagio";
                showError(msg);
            }
        }
    }

    async function handleOrderChange(e, estagio_id, ordem) {
        console.log('HANDLE ORDER CHANGE')
        e.preventDefault()
        try {
            setOrdenando(true)
            await api.post(`/common/empresas/${empresa.id}/funis/${funilId}/estagios/${estagio_id}/ordenar`,
                {
                    ordem
                });
            notify("success", "Ordem alterada");
            reload();
        } catch (error) {
            console.error(error);
            notify("danger", "Não foi possível alterar ordem");
        } finally {
            setOrdenando(false)
        }
    }

    async function handleSaveColor(e, estagio, cor) {
        e.preventDefault()
        try {
            setChangeColor(true)
            await api.post(`common/empresas/${empresa.id}/funis/${funilId}/estagios/${estagio.estagio_id}/cores`,
                {
                    cor
                })
            reload()
        } catch (error) {
            console.error(error)
            notify('danger', "Não conseguimos mudar a cor do estagio")
        } finally {
            setChangeColor(false)
        }
    }

    const askSetConversao = (estagio) => {
        setAlert(
            <Portal id="sweet-alert-portal">
                <ReactBSAlert
                    warning
                    closeOnClickOutside={false}
                    style={{ display: "block", maxWidth: "500px" }}
                    title="Atenção"
                    onConfirm={() => {
                        setAlert(null);
                        handleSetConversao(estagio);
                    }}
                    onCancel={() => setAlert(null)}
                    showCancel
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    confirmBtnText="Sim, definir!"
                    cancelBtnText="Cancelar"
                    btnSize=""
                >
                    Deseja definir o estágio "{estagio.nome}" como o estágio de conversão de oportunidades?
                </ReactBSAlert>
            </Portal>
        );
    };

    async function handleSetConversao(estagio) {
        try {
            await api.put(`/common/empresas/${empresa.id}/funis/${funilId}/estagios/${estagio.id}/conversao`);
            notify("success", "Estágio de conversão atualizado");
            reload();
        } catch (error) {
            console.error(error);
            notify("danger", "Não foi possível atualizar estágio de conversão");
        }
    }

    function createOrdemSelection(ordem) {
        const options = []
        for (let i = ordem; i > 0; i--) {
            options.push(<option key={i}>#{i}</option>)
        }
        return options.reverse()
    }

    return (
        <>
            {alert}
            <ListGroup className="list mt-4" flush>
                {
                    estagios.map((estagio, key) => (
                        <ListGroupItem
                            draggable
                            className="list-group-item-action px-0"
                            style={{ flexDirection: 'row', display: 'flex', flex: 1, alignItems: 'center' }}
                            key={key}>
                            <div className="col-auto">
                                <Button
                                    className="btn-sm"
                                    color="danger"
                                    onClick={(e) => {
                                        e.preventDefault()
                                        handleDelete(estagio)
                                    }}
                                >
                                    <i class="fas fa-trash"></i>
                                </Button>
                            </div>
                            <div className="col-auto">
                                <ColorCircle
                                    estagio={estagio}
                                    handleSaveColor={handleSaveColor} />
                            </div>
                            <Row
                                style={{ flex: 1 }}
                                className="align-items-center">
                                <div className="col col-12">
                                    <h4 className="mb-0">
                                        <a href="#" onClick={e => e.preventDefault()}>
                                            {estagio.nome}
                                        </a>
                                    </h4>
                                </div>
                                <div className="col col-lg-1">
                                    {
                                        ordenando ?
                                            <Spinner size='sm' color='primary' />
                                            :
                                            <Input
                                                size='sm'
                                                type="select"
                                                //className='form-control-flush'
                                                style={{ width: "auto" }}
                                                onChange={(e) => handleOrderChange(e, estagio.id, e.target.value.replace('#', ''))}
                                                value={`#${key + 1}`}
                                            >
                                                {
                                                    createOrdemSelection(key + 1)
                                                }
                                            </Input>
                                    }
                                </div>
                            </Row>
                            <div className="col-auto" title={estagio.flag_conversao ? 'Estágio de Conversão' : 'Não é estágio de conversão'}>
                                <i
                                    className="fas fa-dollar-sign"
                                    onClick={() => askSetConversao(estagio)}
                                    style={{
                                        fontSize: '1.2rem',
                                        color: estagio.flag_conversao ? '#2dce89' : '#ccc',
                                        opacity: estagio.flag_conversao ? 1 : 0.4,
                                        cursor: 'pointer'
                                    }}
                                />
                            </div>
                        </ListGroupItem>
                    ))
                }
            </ListGroup>
        </>
    )
}

export default List;